import React, { useContext } from "react";
import ListDisplayContext from "./ListDisplayContext";
import BrandSmall from "./BrandSmall";

const Columns = () => {
    const { brandsGroups, selectedBrand, setSelectedBrand } = useContext(ListDisplayContext);

    return (
      <div className="row">
          <div className="col-12 d-none d-lg-block">
              <div className="row">
                  <div className="col-4 no-padding proprietary-wrapper">
                      <div className="title proprietary text-center">
                        {Drupal.t("Proprietary brands")}
                      </div>
                  </div>
                  <div className="col-4 no-padding">
                      <div className="title franchise text-center">
                        {Drupal.t("Franchise brands")}
                      </div>
                  </div>
                  <div className="col-4 no-padding virtual-wrapper">
                      <div className="title virtual text-center">
                        {Drupal.t("Virtual brands")}
                      </div>
                  </div>
              </div>
          </div>
          <div className="col-12 col-lg-4 proprietary-wrapper">
            <div className="row">
                <div className="col-12 d-block d-lg-none">
                    <div className="title proprietary text-center">
                        {Drupal.t("Proprietary brands")}
                    </div>
                </div>
            </div>
              <div className="row">
                  <div className="col-12">
                      {brandsGroups.proprietary.map((brand, key) => (
                          <div className={"brand-container-" + brand.id}  key={"brand-container-" + brand.id}></div>
                      ))}
                      {brandsGroups.proprietary.map((brand, key) => (
                          <BrandSmall brand={brand} key={"brand-small-" + brand.id} />
                      ))}
                  </div>
              </div>
              <div className="row">
                {brandsGroups.proprietary.map((brand, key) => (
                      <div className="col-6" key={"proprietary-" + key} onClick={() => setSelectedBrand(brand.id)}>
                          <div className="brand p-3 d-flex align-content-center justify-content-center border">
                              <img className="img-fluid" src={brand.logoUrl} alt={brand.name}/>
                          </div>
                      </div>
                ))}
              </div>
          </div>
          <div className="col-12 col-lg-4">
              <div className="row">
                  <div className="col-12 d-block d-lg-none">
                      <div className="title franchise text-center">
                        {Drupal.t("Franchise brands")}
                      </div>
                  </div>
              </div>
              <div className="row">
                  <div className="col-12">
                      {brandsGroups.franchise.map((brand, key) => (
                          <div className={"brand-container-" + brand.id}  key={"brand-container-" + brand.id}></div>
                      ))}
                      {brandsGroups.franchise.map((brand, key) => (
                          <BrandSmall brand={brand} key={"brand-small-" + brand.id} />
                      ))}
                  </div>
              </div>
              <div className="row">
                  {brandsGroups.franchise.map((brand, key) => (
                      <div className="col-6" key={"franchise-" + key} onClick={() => setSelectedBrand(brand.id)}>
                          <div className="brand p-3 d-flex align-content-center justify-content-center border">
                              <img className="img-fluid" src={brand.logoUrl} alt={brand.name}/>
                          </div>
                      </div>
                  ))}
              </div>
          </div>
          <div className="col-12 col-lg-4 virtual-wrapper">
              <div className="row">
                  <div className="col-12 d-block d-lg-none">
                      <div className="title virtual text-center">
                        {Drupal.t("Virtual brands")}
                      </div>
                  </div>
              </div>
              <div className="row">
                  <div className="col-12">
                      {brandsGroups.virtual.map((brand, key) => (
                          <div className={"brand-container-" + brand.id}  key={"brand-container-" + brand.id}></div>
                      ))}
                      {brandsGroups.virtual.map((brand, key) => (
                          <BrandSmall brand={brand} key={"brand-small-" + brand.id}/>
                      ))}
                  </div>
              </div>
              <div className="row">
                  {brandsGroups.virtual.map((brand, key) => (
                      <div className="col-6" key={"virtual-" + key} onClick={() => setSelectedBrand(brand.id)}>
                          <div className="brand p-3 d-flex align-content-center justify-content-center border">
                              <img className="img-fluid" src={brand.logoUrl} alt={brand.name}/>
                          </div>
                      </div>
                  ))}
              </div>
          </div>
      </div>
    );
};
export default Columns;
